import axiosClient from "./axiosClient";

export const getPrompt = async (storeUuid) => {
    const response = await axiosClient.get(`/stores/${storeUuid}/prompt`);
    return response.data.data.prompt;
};

export const createPrompt = async (storeUuid, prompt) => {
    const response = await axiosClient.post(`/stores/${storeUuid}/prompt`, { prompt });
    return response.data.data;
};

export const updatePrompt = async (storeUuid, prompt) => {
    const response = await axiosClient.put(`/stores/${storeUuid}/prompt`, { prompt });
    return response.data.data;
};

export const deletePrompt = async (storeUuid) => {
    const response = await axiosClient.delete(`/stores/${storeUuid}/prompt`);
    return response.data;
};
